import { createStore } from 'vuex';
import modules from '@/store/shared/index.js';
import RECORD_MUTATIONS from '@/store/lib/mutations';
import { setApiStore } from '@/api';

const store = createStore({
  mutations: {
    ...RECORD_MUTATIONS,
  },

  modules: {
    shared: {
      ...modules,
    },
  },
});

setApiStore(store);

export default store;
